/***
 * 创建人：张丽莉
 * 时间：2019-08-02
 * 描述:动态表单增加,修改 
 * 使用说明: 参考 sw-form-design-add 配置应用说明文档
 * 更新说明:
 */
import { Component, OnInit, ElementRef, ViewChild, EventEmitter, AfterViewInit, Input, Injector, ComponentFactoryResolver, ApplicationRef } from '@angular/core';
import { SwHttpClientService } from '../../../serves/sw-http-client.service';
import { BdpService } from '../../../../areas/bdp/bdp.service';
import { NgModel } from '@angular/forms';
import { Observable } from 'rxjs';
import { Output } from '@angular/core';
import { RefFileObjectService } from "../../../serves/public/ref-file-object.service";
import { NgForm } from '@angular/forms';
import { SwMassageBoxService } from "../../../serves/sw-massage-box.service";
import { environment } from 'src/environments/environment';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwDynamicFormLinkFormComponent } from '../sw-dynamic-form-link-form/sw-dynamic-form-link-form.component'
import { SwDynamicFormLinkUserComponent } from '../sw-dynamic-form-link-user/sw-dynamic-form-link-user.component'
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { DatePipe } from '@angular/common';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwDynamicFormLinkOrganizeComponent } from '../sw-dynamic-form-link-organize/sw-dynamic-form-link-organize.component';
declare var $: any;

@Component({
  selector: 'sw-dynamic-form-add-tab',
  templateUrl: './sw-dynamic-form-add-tab.component.html',
  styleUrls: ['./sw-dynamic-form-add-tab.component.css'],
})
export class SwDynamicFormAddTabComponent implements OnInit, AfterViewInit {
  @ViewChild('f') f: NgForm; //表格对象
  @ViewChild("paramName") paramName: NgModel;
  @ViewChild("link") link: SwDynamicFormLinkFormComponent;
  @ViewChild('modal') modal: SwModalframeComponent; //模态框组件
  isShow = false;
  formInformation: FormInformtion = {
    formName: "",
    formCode: "",
    description: "",
    areas: [{ areaId: '1', colId: '0', px: '0' ,title:''}],
    status: 1,
    params: []
  };
  elements;
  information = {
    _paramName: "",
    result: ""
  }
  view = false; // 是否是查看
  formValue = {}; // 用于封装表单数据
  action;// 区分增删改查操作
  formId;
  keyParam: any = {}; //主键元素
  @Output() getList = new EventEmitter(); // 用于保存成功刷新页面
  headerLoGo = "表单预览";
 
  fileIsReadOnly: boolean = false    //是否只读
  fileBusinessId: string = ''    //业务id  
 
  fileCode2 = {}; //为上传图片组件functionId 策略
  fileCode1 = {}; // 为上传附件组件的functionId 策略
  dataId: any = "";//新增时  策略id参数
  //上传组件参数

  //上传图片事件对象
  getInfoFromImgUpload={};
  //上传图片组件参数对象
  uploadImgAddList= {};
  uploadImgDelList= {};

  //上传附件事件对象 在此方法中接受上传组件按传递过来的文件信息
  getInfoFromFileUpload = {}
  //上传附件事件对象 保存附件表中文件书顺序
  getListSort = {}
  //上传附件组件参数对象
  attachmentDelList = {}
  attachmentAddList = {}

  dictionaryDatas: any = [];//获取所有字典数据

  keyTableId: string = "";//主键元素tableId
  
  ueFlag: any = 'DIR/UEDITOR/COMMONDYNAMICVENUE'
  environmentCkeditor = environment.staticFileUrl; //富文本编辑
  environmentWebAPI = ''//保存webAPI
  closeUrl = ''//页面关闭后跳转的页面
  WebAPIType = '' //业务类型  用于关闭当前页面的路径判断

  pairsElements:any =[];// 来自副数据表表单元素

  prefix: string = environment.seekerWebAPI;

  keyPairParamCode: any = {};//主表外键和对应副表的code键值对

  checkboxRadioRequired: any = {}; //单选框和多选框为必填元素的paramCode和选择值 组成的键值对 
  isBtnDisabled:boolean = true; //单选框和多选框必填项其中有一个值为空   保存按钮为disabled 
  checkboxRadioRequiredNum:number = 0; //统计单选框和多选框必填数量

  isMoreClickBtn: boolean = false;  //多次点击保存事件

  startAndEndDate: any = {}; //当时间为一对时间控件 起始时间和结束时间 保存时需要对时间进行判断  起始时间要小于结束时间  为一对键值对  key为起始时间的paramCode  value为结束时间paramCode

  isUseOrg:boolean = false; //判断表单属性是否有 isOrg=true的情况,如果有则isUseOrg=true,反之isUseOrg=false（execute的接口用到;新增、修改、删除和查询表单时用到）
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  userModel; // 当前登录用户

  constructor(
    public element: ElementRef,
    private http: SwHttpClientService,
    private service: BdpService,
    private fileService: RefFileObjectService,
    private box: SwMassageBoxService,
    private create: SwCreateModalComponentService,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private systemId:SystemIdService,
    private activedRouter: ActivatedRoute,
    private router: Router,
    private tagServe: SwTabService,
    private user: GetUserModelService, //获取用户信息
    private datePipe: DatePipe,
    private jwt: SwJwtService,
  ) {
    this.activedRouter.queryParams.subscribe((param) => {
       this.userModel = this.user.getUser();
       let data = JSON.parse(param['data'])
       this.WebAPIType = data['environment'];
       let webApi = data['environment']+'WebAPI';
       this.environmentWebAPI = environment[webApi];
       this.closeUrl = data['closeUrl']
       //动态获取富文本上传图片，上传flash的服务地址文件名称
       let uploadName = this.closeUrl.split('/')[2]
       this.ueFlag = uploadName.toUpperCase()+'/UEDITOR/COMMONDYNAMICVENUE'
       this.configCkeditor.serverUrl = environment.fileWebAPI + "ueditor/ueditorCtrl?systemId=" + this.systemId.getSystemId() + "&flagDirectory=" + this.ueFlag;
       let formId = data['formId'];
       let checkedId = data['checkedId'];
       if(param.Title){
        this.locationFormInfo(formId, checkedId)
       }
    
    })
   }


  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  //根据表单id获取表单元素信息;根据已选择的表格行id获取该行的所有信息
  locationFormInfo(formId, checkedId) {
    //根据表单id获取表单元素信息
    this.queryParamsPageList(formId).subscribe(response => {
      let params = [];
      let tableId;
      let primaryKey;
      params = (<any>response).data.records;
      this.formInformation['params'] = params;
      this.formInformation['formId'] = formId;
      if (params.length) {
        let keyparam = params.filter(item => item.type == 'key');
        keyparam.forEach(val=>{
           //获取主数据表 对应的绑定主键列表
           if(val.controlType == 'text'){
             tableId = val['tableId']
             primaryKey = val['paramCode']
           }
        })
        //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
        this.getTableFk(tableId);
        //获取起始时间和结束时间的字段标识键值对 startAndEndDate
        let startAndEndDateParam = params.filter(item => item.controlType == 'datePicker' && item.type);
        startAndEndDateParam.forEach(val=>{
          //val.paramCode 代表起始时间字段标识    val.type代表结束日期字段标识
          this.startAndEndDate[val.paramCode] = val.type
        })
       
      }
      //如果checkedId 存在 为修改页面 需要获取选中的行数据
      if(checkedId){
        //获取选中行的数据
        setTimeout(()=>{
          this.getPageList(tableId,formId,primaryKey,checkedId,this.formInformation)
        },200)
       
      }else {
        setTimeout(()=>{
          //checkedId 不存在 为新增页面
          let checkedData = null;
          this.initFormInformation(this.formInformation, checkedData)
        },200)
      }
    })
  }

  /**
 * 查询列表
 * @param {any} formId 
 * @param {any} pager 
 * @param {any} param //查询条件
 * @memberof TestListComponent
 */
getPageList(tableId,formId,primaryKey,checkedId,formInformation) {
  const url = this.environmentWebAPI+'dynamic/'+ 'execute?action=1&formId=' + formId + `&isUseAlias=true&pageNum=${1}&pageSize=${10}&isUseOrg=${this.isUseOrg}`;
  // 过滤已删除的数据
  let param = {}
  let checkedData;
  param[tableId+'.'+ primaryKey] = ['like',checkedId, '']
  // 查询业务数据
  this.http.Post(url, param).subscribe(res => {
    let val = (<any>res).data.data.list;
    val.forEach(ele=>{
      if(ele[primaryKey] == checkedId){
        checkedData = ele;
        //初始化表单元素
        this.initFormInformation(formInformation, checkedData)
      }
    })

  })
}


  //解决ckeditor在bootstrap中modal中弹框无法输入问题
  fixCkeditor(formInformation) {
    formInformation.params.forEach(val => {
      if (val.controlType == 'ckeditor') {
        //
        $.fn.modal.Constructor.prototype.enforceFocus = function () {
          $(document)
            .off('focusin.bs.modal')
            .on('focusin.bs.modal', $.proxy(function (e) {
              if (
                this.$element[0] !== e.target && !this.$element.has(e.target).length
                && !$(e.target).closest('.cke_dialog, .cke').length
              ) {
                this.$element.trigger('focus')
              }
            }, this))
        }
      }
    })
  }
  //上传图片  上传附件  
  staticFileCodeData() {
    this.fileCode2 = {};
    //以下为上传图片 上传文件 文件标识的假数据
    this.formInformation.params.forEach(val => {
      if (val.controlType == 'image') {
        //真数据 暂时注释
        if (val['description']) {
          this.fileCode2[val.paramCode+val.imageSort] = val['description'];
        }
      }
      if (val.controlType == 'files') {
        if (val['description']) {
          this.fileCode1[val.paramCode+val.filesSort] = val['description'];
        }
      }
    })

  }
  
  // 接收表单信息,初始化表单内容
  initFormInformation(formInformation, checkedData) {
    this.formValue = {};
    this.fileBusinessId = '';
    this.formId = formInformation.formId;
    this.formInformation = formInformation;
    // 过滤出表单元素 
    this.elements = this.formInformation.params;
    //过滤出单选框和多选框必填元素
    this.elements.forEach(val=>{
      if((val.controlType=='radio' || val.controlType=='checkbox') && (val.isNotNull == '1' || val.isNotNull)){
        this.checkboxRadioRequired[val.paramCode] = '';
        this.checkboxRadioRequiredNum+=1;
      }
    })
    // 过滤出主键元素
    let keyparams = this.formInformation.params.filter(item => item.type == 'key');
    keyparams.forEach(val=>{ 
       //获取主数据表 对应的绑定主键列表
       if(val.controlType == 'text'){
        this.keyParam = val;
        this.keyTableId = val.tableId;
       }
    })
    //获取和来自副数据表的表单元素
    this.pairsElements = this.elements.filter(item => item.tableId != this.keyTableId);
    
    //如果元素有ckeditor  解决ckeditor在bootstrap中modal中弹框无法输入问题
    this.fixCkeditor(this.formInformation)
    //获取字典数据
    //从浏览器缓存获取字典数据
    let dic = JSON.parse(this.jwt.getToken('dictionary'))
    this.dictionaryDatas = [...dic]
    //用于存储接受的数据
    this.initRequest(this.elements, checkedData);
      // let Params = { "param": { pageSize: 0 } };
      // this.service.getDictionaryService().queryDictionaryPageList(Params).subscribe(data => {
      //   if(data["code"] == 200){
      //     this.dictionaryDatas = [...data["data"]["records"]]
      //     //用于存储接受的数据
      //     this.initRequest(this.elements, checkedData);
      //   }
      // })
    //用于静态设置上传图片序号 事件 变量
    this.sortElementsImage();
    //用于静态设置上传附件事件 变量
    this.sortElementsFiles()
    //上传图片 附件的策略赋值
    this.staticFileCodeData();
    // 初始化区域
    this.initAreas();
      // 修改
    if (checkedData) {
      this.headerLoGo = "修改";
      for (const key in checkedData) {
        if (checkedData[key] === true || checkedData[key] === false) {
          checkedData[key] = checkedData[key] + ''
        }
      };
      //若为修改时 单选框 多选框获取对应值
      for(const key in  this.checkboxRadioRequired) {
        this.checkboxRadioRequired[key] = checkedData[key] + '';
      }
      this.action = 3;
      this.formValue = {};
      this.formValue = { ...checkedData }
      //富文本转换绝对路径 用于显示在页面上
      this.toAbsolutePath();
      //获取业务id  现在写死 实际应从checkedData获取
      //获取主键的字段
      let paramCode = this.keyParam['paramCode'];
      this.fileBusinessId = checkedData[paramCode];
      // 新增 
    } else {
      this.headerLoGo = "新增";
      this.action = 2;
      this.formValue = {};
      //当表单设计为新增时 若元素为text或者为textarea,并且设置defaultValue值时 需要显示出来 
      this.formInformation.params.forEach(val => {
        if ((val.controlType == 'text' || val.controlType == 'textarea') && val.defaultValue != null && val.defaultValue != '') {
          this.formValue[val.paramCode] = val.defaultValue
        }
      })
      this.initFormValue(this.formInformation.params)
    }
     //判断单选框和多选框必填项是否为空
     this.judgeCheckboxRadio()
  }

  //判断单选框和多选框必填项是否为空
  judgeCheckboxRadio() {
    let $num =0; 
    for(const key in  this.checkboxRadioRequired) {
      if(this.checkboxRadioRequired[key]) {
        $num+=1;
      }
    }
    if(this.checkboxRadioRequiredNum == $num) {
      this.isBtnDisabled = false
    }else {
      this.isBtnDisabled = true;
    }
  }

  //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
  getTableFk(keyTableId){
    let param = { ids:[ keyTableId],systemId:this.systemId.getSystemId()};
    let keyParamCode = '';//主表是外键的code
    let pairParamCode =  '';//主表为外键的code 绑定的副表code值
    //根据主表tableId查询对应的 主键字段列表
    this.service.getFormDesignService().queryColumnsByTableId(param).subscribe(res => {
      if(res['code']==200){
        let columns = res['data'];
        columns.forEach(val=>{
          if(val.isFk){
            keyParamCode = val.columnCode
            let pairParamCodeArray = this.elements.filter(item=> item.columnId == val.fkColumnId)
            if(pairParamCodeArray.length>0) {
              pairParamCode = pairParamCodeArray[0]['paramCode'];
              this.keyPairParamCode[keyParamCode] = pairParamCode;
            }
          }
        })
         //判断主表是否为组织权限
         if(columns.length > 0){
          //判断该表单的是否包含属性 isOrg = true的元素，若有 this.isUseOrg = true 否则 this.isUseOrg=false
          let orgs = columns.filter(item=>item.isOrg == true)
          if(orgs.length == 0){
            this.isUseOrg=false
          }else {
            this.isUseOrg = true
          }
        }
      }
      

    });
  }
  //对formValue初始值,其为图片 上传文件
  initFormValue(params) {
    params.forEach(val => {
      if ((val.controlType == 'files' || val.controlType == 'image') && val.paramCode) {
        this.formValue[val.paramCode] = '';
      }
    })
  }
  //对元素含有图片元素进行排序编号 以便对策略id和对应事件 变量进行分类
  sortElementsImage() {
    let i = 0;
    this.elements.forEach(element => {
      if (element.controlType == 'image') {
        i++;
        element.imageSort = i;
        //初始上传图片 初始变量 加上imageSort的原因是 当上传图片paramCode为中文时 两个及以上便于分辨
        let imageParamCode = element.paramCode+element.imageSort;
        this.uploadImgAddList[imageParamCode] = [];
        this.uploadImgDelList[imageParamCode] = [];
         //初始上传图片初始事件
        this.getInfoFromImgUpload[imageParamCode] = (event)=> {
          this.uploadImgAddList[imageParamCode] = event.addList;
          this.uploadImgDelList[imageParamCode] = event.delList
        }
      }
    });
  }
  //对元素含有文件元素进行排序编号 以便对策略id和对应事件 变量进行分类
  sortElementsFiles() {
    let i = 0;
    this.elements.forEach(element => {
      if (element.controlType == 'files') {
        i++;
        element.filesSort = i;
        //初始上传附件初始事件 初始变量 加上filesSort的原因是 当上传附件paramCode为中文时 两个及以上便于分辨
        let filesParamCode = element.paramCode+element.filesSort;
        this.attachmentDelList[filesParamCode] = [];
        //在此方法中接受上传组件按传递过来的文件信息
        this.getInfoFromFileUpload[filesParamCode] = (event)=> {
          this.attachmentDelList[filesParamCode] = event.delList;
        }
        //保存附件表中文件书顺序
        this.attachmentAddList[filesParamCode] = [];
        this.getListSort[filesParamCode] = (event)=> {
          this.attachmentAddList[filesParamCode] = event;
        }
      }
    });
  }
  //初始区域
  initAreas() {
    //找出区域 列 px 的信息
    let arr = []
    this.formInformation.params.forEach(val => {
      if(val.groupName) {
        val.groupName1 = JSON.parse(val.groupName)
        let num = 0;
        arr.forEach(ele => {
          if (val.groupName1.areaId == ele.areaId) {
            num = 1;
          }
        })
        if (num == 0) {
          arr.push(val.groupName1)
        }
      }
    })
    this.formInformation.areas = arr;
  }
  //保存时 保存参数做非空和正则规则判断  满足条件可以保存 不满足则弹框
  isSubmit(elements, formValue) {
    let judgeNull = 0; //判断非空
    let judgeReg = 0; //判断正则
    let judgeDate = 0; //判断日期 判断开始日期是否大于等于结束日期
    let judgeLength = 0; //判断字符数， 最大字符数和最小字符数
    let dateStr = '' ; //日期提示信息
    let regStr = ''; //正则提示信息 
    let lengthStr = ''; //最大字符和最小字符数提示
    this.toRelativePath();
    elements.forEach(val => {
      //非空判断 (不包括上传图片和上传附件)
      if (val.isNotNull && val.controlType != 'image' && val.controlType != 'files' && (formValue[val.paramCode] === '' || formValue[val.paramCode]=== null || formValue[val.paramCode] === undefined)) {
        judgeNull = 1;
      }
      //非空判断 (包括上传图片)
      if(val.isNotNull && val.controlType == 'image') {
        //判断上传图片组件非空
        if(!formValue[val.paramCode] && this.uploadImgAddList[val.paramCode+val.imageSort].length == 0 ) {
          judgeNull = 1;
        }
     
      }
      //非空判断 （包括上传附件）
      if(val.isNotNull && val.controlType == 'files') {
        //判断上传附件组件非空
        if(!formValue[val.paramCode] && this.attachmentAddList[val.paramCode+val.filesSort].length == 0) {
          judgeNull = 1;
        }
      }
      //判断最大字符数和最小字符数
      if(val.length || val.minLength){
        let formValueStr = formValue[val.paramCode]+'';
          if(val.length  && !val.minLength){
              if(formValueStr.length > val.length){
                judgeLength = 1;
                lengthStr=val.paramName+'的最大字符数为'+val.length
              }
          }else if(!val.length  && val.minLength){
              if(formValueStr.length < val.minLength){
                  judgeLength = 1;
                  lengthStr=val.paramName+'的最小字符数为'+val.minLength
              }
          }else {
              if(formValueStr.length > val.length || formValueStr.length < val.minLength){
                judgeLength = 1;
                lengthStr=val.paramName+'的最小字符数为'+val.minLength+'，最大字符数为'+val.length
              }
          }
      }
      //正则
      let reg = val.formula;
      let re = new RegExp(reg)
      //利用switch判断正则 因为当正则为字符串，字符串或空时  正则表达式找不到  所以用if判断
      if (val.formula) {
        //利用switch判断正则
        switch (val.validatePrompt) {
          case '必须为字符串':
            if ((typeof formValue[val.paramCode]) != 'string') {
              judgeReg = 1;
              regStr = val.paramName +'输入格式为'+ val.validatePrompt;
            };
           break;
          case '字符串或空':
            if ((typeof formValue[val.paramCode]) != 'string' && formValue[val.paramCode] != null) {
              judgeReg = 1;
              regStr = val.paramName +'输入格式为'+ val.validatePrompt;
            };
            break;
          case '数字或空':
            if (!re.test(formValue[val.paramCode]) && formValue[val.paramCode] != null) {
              judgeReg = 1;
              regStr = val.paramName +'输入格式为'+ val.validatePrompt;
            }; 
            break;
          default:
             //用对应正则表达式验证数据
             if (!re.test(formValue[val.paramCode])) {
              judgeReg = 1;
              regStr = val.paramName +'输入格式为'+ val.validatePrompt;
            };
             break;
        }
      }
    })
    //判断日期startAndEndDate 与对应的formValue的值大小 judgeDate
    for(var v in this.startAndEndDate){
      let startDateCode = v; //开始时间的字段标识
      let endDateCode = this.startAndEndDate[v]; //结束时间字段标识
      let startParamName = this.elements.filter(el=>el.paramCode == startDateCode)[0]['paramName']; //开始时间的paramName 
      let endParamName = this.elements.filter(el=>el.paramCode == endDateCode)[0]['paramName']; //结束时间的paramName
      if(this.formValue[startDateCode] >= this.formValue[endDateCode]) {
        judgeDate = 1;
        dateStr = startParamName + '不能大于或等于' + endParamName
      }
    }
    
    if (judgeNull == 1 || judgeReg == 1) {
      if (judgeNull == 1 && judgeReg == 0) {
        this.box.waringError('必填标识不能为空')
      } else if (judgeNull == 0 && judgeReg == 1) {
        this.box.waringError(regStr)
      } else {
        let str = '必填标识不能为空且' + regStr;
        this.box.waringError(str)
      }
      return false
    } else if(judgeDate == 1){
      this.box.waringError(dateStr)
      return false
    } else if(judgeLength == 1){
      this.box.waringError(lengthStr)
      return false
    }else{
      return true
    }

  }
  // 新增或修改确定
  saveOrUpdate() {
    if (this.isSubmit(this.elements, this.formValue)) {
      // 新增
      if (this.action == 2) {
        this.isMoreClickBtn = true;
        let data = this.formatData(this.elements, this.formValue, 2);
        this.execute(data, 2, this.formId).subscribe(res => {
          if (res["code"] == 200) {
            //动态获取一个业务id 此前为静态数据 需要从后台获取
            this.elements.forEach(val=>{
              if(val.controlType == 'image'){
                this.saveFile(this.uploadImgAddList[val.paramCode+val.imageSort], this.dataId, this.fileCode2[val.paramCode+val.imageSort]);
              }
              if(val.controlType == 'files') {
                this.saveFile(this.attachmentAddList[val.paramCode+val.filesSort], this.dataId, this.fileCode1[val.paramCode+val.filesSort]);
              }
            })
            this.box.success("操作成功");
            this.clear()
            this.clickClose()
          }else {
            this.box.danger("操作失败");
          }
          this.isMoreClickBtn = false;
          
        });
      } else { //修改
        let data = this.formatData(this.elements, this.formValue, 3);
        this.execute(data, 3, this.formId).subscribe(res => {
          if (res["code"] == 200) {
            this.elements.forEach(val=>{
              if(val.controlType == 'image'){
                this.saveFile(this.uploadImgAddList[val.paramCode+val.imageSort], this.fileBusinessId, this.fileCode2[val.paramCode+val.imageSort]);
                this.delFile(this.uploadImgDelList[val.paramCode+val.imageSort]);
              }
              if(val.controlType == 'files') {
                this.saveFile(this.attachmentAddList[val.paramCode+val.filesSort], this.fileBusinessId, this.fileCode1[val.paramCode+val.filesSort]);
                this.delFile(this.attachmentDelList[val.paramCode+val.filesSort]);
              }
            })
            this.box.success("操作成功");
            this.clear()
            this.clickClose()
          }else {
            this.box.danger("操作失败");
          }
          
        });

      }
    }
  }
  
  //成功之后,将列表刷新 
  clickClose() {
    let projectName = this.closeUrl.split('/')[2]
    if(this.action == 2) {
      this.tagServe.closeUrl("/"+this.WebAPIType+"/DynamicFormAdd/"+projectName, true);
    }else if(this.action == 3) {
      this.tagServe.closeUrl("/"+this.WebAPIType+"/DynamicFormEdit/"+projectName, true);
    }
    this.tagServe.refurbis(this.closeUrl)
  }
  //点击取消
  clickCancel(){
    let projectName = this.closeUrl.split('/')[2]
    if(this.action == 2) {
      this.tagServe.closeUrl("/"+this.WebAPIType+"/DynamicFormAdd/"+projectName, true);
    }else if(this.action == 3) {
      this.tagServe.closeUrl("/"+this.WebAPIType+"/DynamicFormEdit/"+projectName, true);
    }
    this.tagServe.gotoUrl(this.closeUrl)
  }
 //清除上传图片，上传附件数组
  clear() {
    this.uploadImgAddList = {};
    this.uploadImgDelList = {};
    this.attachmentAddList= {};
    this.attachmentDelList= {};
  }

  // 获取32位uuid
  getUUID() {
    let s = [];
    let hex = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hex.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hex.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "";
    let uuid = s.join("");
    return uuid;
  }
  //日期最小值初始化  
  minDateChange(element) {
    let startDateValue = ''; //若为时间对的最小时间值
    let returnValue = ''; //返回的最小时间值
    let paramCode = element.paramCode; //获取元素的paramCode
     //判断日期的起始日期  若为一对日期 则需要判断该日期对应的起始日期值
     for(var key in this.startAndEndDate) {
      let endDateCode = this.startAndEndDate[key]
      //若元素为结束时间  需要获取起始时间的值作为开始时间的最大值
      if(endDateCode == paramCode) {
        startDateValue = this.formValue[key]
      }
    }
    if(startDateValue) {
      returnValue = startDateValue; // 时间对的起始日期
    }else if(element.startDate) {
      returnValue = element.startDate; // 表单设计的最小值
    }else {
      returnValue = '1900-01-01 00:00:00' ; //默认值
    }
    return returnValue
  }

  //日期最大值初始化  
  maxDateChange(element) {
    let endDateValue = ''; //若为时间对的最大时间值
    let returnValue = ''; //返回的最大时间值
    let paramCode = element.paramCode; //获取元素的paramCode
    //判断日期的截止日期  若为一对日期 则需要判断该日期对应的结束日期值
    for(var key in this.startAndEndDate) {
      //若元素为开始时间  需要获取结束时间的值作为开始时间的最大值
      if(key == paramCode) {
       let endDateCode = this.startAndEndDate[key]
        endDateValue = this.formValue[endDateCode]
      }
    }
    if(endDateValue) {
      returnValue = endDateValue; // 时间对的结束日期
    }else if(element.endDate) {
      returnValue = element.endDate; // 表单设计的最大值
    }else {
      returnValue = '2099-12-31 23:59:59' ; //默认值
    }
    return returnValue
  }
  //点击单选框获取数据
  radioOnChange(e, val, element) {
    if (e.target.checked) {
      this.information[element.paramCode] = [];
      this.information[element.paramCode].push(val.id);
      this.formValue[element.paramCode] = val.id + '';
      if(element.isNotNull == '1' || element.isNotNull){
        this.checkboxRadioRequired[element.paramCode] = val.id + '';
       }
      //判断单选框和多选框必填项是否为空
      this.judgeCheckboxRadio();
    }

  }
  //点击多选框获取数据
  onChange(e, val, element) {
    if (!this.information[element.paramCode]) {
      this.information[element.paramCode] = []
    }
    if (e.target.checked) {
      this.information[element.paramCode].push(val.id)
    } else {
      for (let i = 0; this.information[element.paramCode].length > i; i++) {
        if (this.information[element.paramCode][i] == val.id) {
          this.information[element.paramCode].splice(i, 1)
        }
      }
    }
    this.formValue[element.paramCode] = this.information[element.paramCode].join(',');
    if(element.isNotNull == '1' || element.isNotNull){
      this.checkboxRadioRequired[element.paramCode] = this.information[element.paramCode].join(',');
     }
    //判断单选框和多选框必填项是否为空
    this.judgeCheckboxRadio();
  }


  initRequest(elements, checkedData) {
     //用于存储接受的数据
    //发送请求的参数
    elements.forEach((value) => {
      let arr = [];
      if (value.requestUrl) {
        //决定数据来源
        let param1 = value.requestUrl.split("/")[1];
        //决定那条数据
        let param2 = value.requestUrl.split("/")[2];
        let type = value['controlType']; //获取元素类型
        //param1：1 数据来源为数据字典， param1：2 数据来源为钉钉用户
         if(param1 == 1) {
            //对数据来源的数据进行过滤
            let requestUrl = this.dictionaryDatas.filter(val => {
              return val.parentId == param2;
            });
            requestUrl = requestUrl.map((val, index) => {
              //将id修改为val.id
              return {
                id: val.dictionaryValue,
                text: val.dictionaryName,
                status: false
              }
            });
            //判断单选，多选状态
      
          if(checkedData){
              let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
              if(checkedDataValue){
              this.information[value.paramCode] = [];
                let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                arr11.forEach(ele => {
                  //判断是否为is_xx true 或者false
                  if (ele == 'true') {
                    ele = '1'
                  } else if (ele == 'false') {
                    ele = '0'
                  }
                  requestUrl.forEach(val => {
                    if (ele == val.id) {
                      val.status = true;
                    }
                  })
                });
                //修改时  对存储信息变量 information 赋值 
                requestUrl.forEach(val => {
                  if (val.status) {
                    this.information[value.paramCode].push(val.id)
                  }

                })
              }
            }
            //确定需要的数据
            value.requestData = requestUrl;
          
        }else {
          //数据来源为钉钉用户
          if(param1 == 2) {
            
          }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')) {
           //数据来源为绑定的表单
            //数据来源为绑定的表单
            let formId = param2
            //根据formId获取关联的表单元素
            this.queryParamsPageList(formId).subscribe(response => {
              let pairParam2='';//关联表单对应的表单字段元素 对应的字典 id
              let params = [];
              params = (<any>response).data.records;
              pairParam2 = params.filter(item=>item['paramCode'] == value['paramCode'])[0]['requestUrl'].split("/")[2];
             
              //对数据来源的数据进行过滤
              let requestUrl = this.dictionaryDatas.filter(val => {
                return val.parentId == pairParam2;
              });
              requestUrl = requestUrl.map((val, index) => {
                //将id修改为val.id
                return {
                  id: val.dictionaryValue,
                  text: val.dictionaryName,
                  status: false
                }
              });
              if(checkedData){
                let checkedDataValue = checkedData[value.paramCode]+''; //设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
                if(checkedDataValue){
                this.information[value.paramCode] = [];
                  let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                  arr11.forEach(ele => {
                    //判断是否为is_xx true 或者false
                    if (ele == 'true') {
                      ele = '1'
                    } else if (ele == 'false') {
                      ele = '0'
                    }
                    requestUrl.forEach(val => {
                      if (ele == val.id) {
                        val.status = true;
                      }
                    })
                  });
                  //修改时  对存储信息变量 information 赋值 
                  requestUrl.forEach(val => {
                    if (val.status) {
                      this.information[value.paramCode].push(val.id)
                    }
  
                  })
                }
              }
              //确定需要的数据
              value.requestData = requestUrl;
            })
          }else if(param1 == 3 && param2 == 1){
            //关联组织数据处理
            //查询组织结构
            let requestUrl;
            let param = { "param": { pageSize: 0 ,isAdminQuery:true}, "entity": {systemId:this.systemId.getSystemId()} }
            this.service.getDepartmentService().queryOrganizePageList(param).subscribe(
              data => {
                if (data["code"] == 200) {
                  let orgarray = [];
                  data["data"]["records"].forEach(e => {
                    if(e.status){
                      e.checked = false;
                      orgarray.push(e);  //筛选掉已禁用数据
                    }
                  });
                  requestUrl = orgarray;
                  //确定需要的数据
                 value.requestData = requestUrl;
                }
              }
            )

          }else if(param1 == 3 && param2 == 2){
           //关联系统用户
           let requestUrl;
           //查询系统所有用户
           let param1 = {systemId: this.systemId.getSystemId()}
           this.service.getUserService().queryList(param1).subscribe( //查询用户
             data => {
               if (data["code"] == 200) {
                 let arr1 = []
                 let result = data["data"]
                 result.forEach(user => {
                   if(user.status){
                     // 查询所有用户，默认没有用户被选中
                     arr1.push({id:user.userId,text:user.displayName,pid:'999',checked:false})
                   }
                 });
                 //所有的用户
                 requestUrl = arr1
                 //确定需要的数据
                 value.requestData = requestUrl;
                
               }
             }
           )
          }
        }
      }
    })
  }
  /**
   * 根据formId查询参数
   * @param param
   * @returns {Observable<any>}
   */
  queryParamsPageList(formId) {
    let param = {
      entity: { formId: formId },
      param: { pageSize: 0, orderBy: "seq" }
    }
    const url = this.prefix + 'form/queryParamsPageList';
    return this.http.Post(url, { ...param });
  }

  //保存上传信息
  saveFile(fileList, relationId, code) {
    let addList = [];
    fileList.forEach(item => {
      let info: any = {};
      info.fileInfoId = item.fileInfoId;
      info.sort = item.sort;
      if (item.fileObjectId != undefined && item.fileObjectId != null && item.fileObjectId != "") {
        info.fileObjectId = item.fileObjectId;
      }
      addList.push(info);
    });
    if (addList.length > 0) {
      this.fileService.save(relationId, code, addList).subscribe();
    }
  }

  //删除已经删除的信息
  delFile(fileList) {
    if (fileList.length) {
      this.fileService.delete(fileList).subscribe();
    }
  }

  //富文本转换相对路径 用于存储到数据库
  toRelativePath() {

    //处理富文本类型 富文本图片视频地址转换为相对路径存储
    //转义双引号
    let aquotes: string = '"'
    let newaQuotes: string = '\"'
    //替换分号
    let branch: string = ';'
    let newBranch: string = 'bra&nch'
 
     let path: string = this.environmentCkeditor;
     let newPath: string = "ht&tp";
     this.formInformation.params.forEach(val => {
       if (val.controlType == 'ckeditor') {
         if(this.formValue[val.paramCode]){
          this.formValue[val.paramCode] = this.formValue[val.paramCode].replace(new RegExp(path, "gm"), newPath);
          let newData = this.formValue[val.paramCode].replace(new RegExp(aquotes, "gm"), newaQuotes);
          this.formValue[val.paramCode] = newData.replace(new RegExp(branch, "gm"), newBranch);
         }
       }
     })
   }
   //富文本转换绝对路径 用于显示在页面上
   toAbsolutePath() { 
    let aquotes: string = '"'
    let newaQuotes: string = '\"'
      //替换分号
    let branch: string = ';'
    let newBranch: string = 'bra&nch'
 
     let path: string = this.environmentCkeditor;
     let newPath: string = "ht&tp";
     this.formInformation.params.forEach(val => {
       if (val.controlType == 'ckeditor') {
         let newData = ''
         newData = this.formValue[val.paramCode]
         //类似以下标签保存成功从新获取 取不到
         //<img alt="smiley" src="http://localhost:4200/assets/Scripts/ckeditor_4.11.1_full/ckeditor/plugins/smiley/images/regular_smile.png" style="height:22px; width:22px" title="smiley" /> 
         if(newData) {
          newData =  newData.replace(new RegExp(newPath, "gm"), path);
          newData.replace(new RegExp(newaQuotes, "gm"), aquotes);
          this.formValue[val.paramCode] =  newData.replace(new RegExp(newBranch, "gm"), branch);
        }
       }
     })
   }

  /**
   * 格式化数据
   * @param {Array<any>} config 表单项内容
   * @param {*} formValue 表单值
   * @param {number} action 增删改操作
   * @returns 
   * @memberof TestListComponent
   */
  formatData(config: Array<any>, formValue: any, action: number) {
    let obj = {}
    //判断字段标识不为中文正则表达式
    let reg = /^[\u4e00-\u9fa5]/;
    //获取当前登录人
    let loginName = this.userModel.loginName
    //获取当前时间戳
    let dateTime = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss')
    // 新增
    if (action === 2) {
      // 格式化表单中的元素
      config.map(item => {
        if (formValue.hasOwnProperty(item.paramCode)) {
          if (!item.isHidden) {
            if(item.tableId == this.keyParam.tableId){
            // 处理时间类型数据
            if (item.controlType == 'datePicker') {
              // obj[item.tableId + '.' + item.paramCode] = ['', '', format(formValue[item.paramCode], 'YYYY-MM-DD:HH:mm:ss')]
              obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
            } else if (item.controlType == 'image') {
              //当字段标识不为中文时
              if(!reg.test(item.paramCode)) {
                 if(this.uploadImgAddList[item.paramCode+item.imageSort].length) {
                  formValue[item.paramCode] = this.uploadImgAddList[item.paramCode+item.imageSort][0].filePath + this.uploadImgAddList[item.paramCode+item.imageSort][0].fileName;
                 }else {
                   if(this.uploadImgDelList[item.paramCode+item.imageSort].length) {
                    formValue[item.paramCode] = null;
                   }
                 }
                 obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
              }
            } else if(item.controlType == 'files'){
                //当字段标识不为中文时
              if(!reg.test(item.paramCode)) {
                if(this.attachmentAddList[item.paramCode+item.filesSort].length) {
                  formValue[item.paramCode] = this.attachmentAddList[item.paramCode+item.filesSort][0].filePath + this.attachmentAddList[item.paramCode+item.filesSort][0].fileName;
                }else {
                  if(this.attachmentDelList[item.paramCode+item.filesSort].length) {
                    formValue[item.paramCode] = null;
                  }
                }
                obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
              }
            } else if (item.controlType == 'ckeditor') {
              //处理富文本类型 富文本图片视频地址转换为相对路径存储
              obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]

            } else {
              //code值不能为中文  排除没有选择字段标识符的上传附件或上传图片 
              if(!reg.test(item.paramCode)) {
                obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
              }
              
            }

           }
          }
        }
        //伪删除赋值为 0
        if(item.type == 'isLogic' && item.tableId == this.keyParam.tableId){
          obj[item.tableId + '.' + item.paramCode] = ['', '', 0]
        }
        //组织权限
        if(item.type == 'isOrg' && item.tableId == this.keyParam.tableId && this.isUseOrg){
          obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
        }
        //判断是否为创建人(creator)
        if(item.paramCode == 'creator' && item.isHidden){
          obj[item.tableId + '.' + item.paramCode] = ['', '', loginName]
        }
        //判断创建时间(create_time)
        if(item.paramCode == 'create_time' && item.isHidden){
          obj[item.tableId + '.' + item.paramCode] = ['', '', dateTime]
        }
      })
      //获取外键id 和副表主键id相等
      for(var v in this.keyPairParamCode){
        let keyParamCode = v;
        let pairParamCode = this.keyPairParamCode[v]
        if(formValue[pairParamCode]){
          obj[this.keyParam.tableId + '.' + keyParamCode] = ['', '', formValue[pairParamCode]]
        }
      }
      // 添加id
      let uuid = this.getUUID();
      this.dataId = uuid; // 新增的策略id
      obj[this.keyParam.tableId + '.' + this.keyParam.paramCode] = ['', '', uuid]
    }


    // 修改
    if (action === 3) {
      // id拼接引号
      config.map(item => {
        if(!item.isHidden){
          if(item.tableId == this.keyParam.tableId){
          // 处理时间类型数据 
          if (item.controlType == 'datePicker') {
            obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
          } else if (item.controlType == 'image') {
              //当字段标识不为中文时
              if(!reg.test(item.paramCode)) {
                if(this.uploadImgAddList[item.paramCode+item.imageSort].length) {
                  formValue[item.paramCode] = this.uploadImgAddList[item.paramCode+item.imageSort][0].filePath + this.uploadImgAddList[item.paramCode+item.imageSort][0].fileName;
                }else {
                  if(this.uploadImgDelList[item.paramCode+item.imageSort].length) {
                    formValue[item.paramCode] = null;
                  }
                }
                obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
              }

          } else if(item.controlType == 'files'){
            //当字段标识不为中文时
            if(!reg.test(item.paramCode)) {
              if(this.attachmentAddList[item.paramCode+item.filesSort].length) {
                formValue[item.paramCode] = this.attachmentAddList[item.paramCode+item.filesSort][0].filePath + this.attachmentAddList[item.paramCode+item.filesSort][0].fileName;
              }else {
                if(this.attachmentDelList[item.paramCode+item.filesSort].length) {
                  formValue[item.paramCode] = null;
                }
              }
              obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
            }
          } else if (item.controlType == 'ckeditor') {
            //处理富文本类型 富文本图片视频地址转换为相对路径存储
            obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]

          } else {
              //code值不能为中文  排除没有选择字段标识符的上传附件或上传图片 
              if(!reg.test(item.paramCode)) {
                obj[item.tableId + '.' + item.paramCode] = ['', '', formValue[item.paramCode]]
              }
          }

         }
       }else {
          //伪删除赋值为 0
          if(item.type == 'isLogic' && item.tableId == this.keyParam.tableId){
            obj[item.tableId + '.' + item.paramCode] = ['', '', 0]
          }
       }
          //判断是否为更新人（updator）
          if(item.paramCode == 'updator' && item.isHidden){
            obj[item.tableId + '.' + item.paramCode] = ['', '', loginName]
          }
          //判断更新时间（update_time）
          if(item.paramCode == 'update_time' && item.isHidden){
            obj[item.tableId + '.' + item.paramCode] = ['', '', dateTime]
          }
      })
     
      //获取外键id 和副表主键id相等
      for(var v in this.keyPairParamCode){
        let keyParamCode = v;
        let pairParamCode = this.keyPairParamCode[v]
        if(formValue[pairParamCode]){
          obj[this.keyParam.tableId + '.' + keyParamCode] = ['', '', formValue[pairParamCode]]
        }
      }
      obj[this.keyParam.tableId + '.' + this.keyParam.paramCode] = ['=', "'" + formValue[this.keyParam.paramCode] + "'", '']
    }

    // 查询
    if (action === 1) {
      if (config.length > 0) {
        config.map(item => {
          obj[item.tableId + '.' + item.paramCode] = ['like', formValue[item.paramCode], '']
        })
      }
    }

    // 物理删除 
    if (action === 4) {

    }

    return obj
  }


  //操作业务数据业务数据
  execute(param, action: number, formId): Observable<any> {
    let url = this.environmentWebAPI + `dynamic/execute?action=${action}&formId=${formId}&isUseOrg=${this.isUseOrg}`;
    return this.http.Post(url, {
      ...param,
    })
  }

//以下为关联系统用户代码 
 //是否关联系统用户
 isLinkUser(requestUrl){
  let arr = requestUrl.split("/");
   //判断arr[1]为3 代表为关联系统用户或组织;  判断arr[2]为2 代表为关联的系统用户
   if( arr[1]=='3' && arr[2]=='2'){
     return true
   }else {
     return false
   }
 }
  //点击获取关联系统用户数据
  clickLinkUser(paramCode,paramName,requestData) {
    let ids = (this.formValue[paramCode]+"").split(',')
    let param = {code: paramCode,userId:ids,name:paramName,data:requestData}
    this.createModal(SwDynamicFormLinkUserComponent,param,this.userLinkData.bind(this))
  }
  //获取关联系统用户选中的数据 
  userLinkData(outDatas) {
    //返回绑定系统用户的字段 paramCode值
    let paramCode = outDatas['paramCode'];
    //返回绑定系统用户的字段 paramValue(返回类型为数组)值
    let paramValue = outDatas['paramValue']
    this.formValue[paramCode] = paramValue;
  }

  //以下为关联组织代码
  //是否为关联组织
  isLinkOrganize(requestUrl){
   let arr = requestUrl.split("/");
   //判断arr[1]为3 代表为关联系统用户或组织;  判断arr[2]为1 代表为关联的组织
   if( arr[1]=='3' && arr[2]=='1'){
     return true
   }else {
     return false

   }
  }
  //点击获取关联组织数据
  clickLinkOrganize(paramCode,paramName,requestData) {
    let param = {code: paramCode,name:paramName,data:requestData,value:this.formValue[paramCode]}
    this.createModal(SwDynamicFormLinkOrganizeComponent,param,this.organizeLinkData.bind(this))
  }
  //获取关联组织选中的数据 
  organizeLinkData(outDatas) {
    //返回绑定关联组织的字段 paramCode值
    let paramCode = outDatas['paramCode'];
    //返回绑定关联组织id
    let paramValue = outDatas['paramValue'];
    this.formValue[paramCode] = paramValue;
  }
 

  //以下为关联表单代码
  //点击获取关联表单的数据
  clickLinkForm(tableId, requestUrl) {
    let formId = requestUrl.split("/")[2];
    let param ={"tableId": tableId , "formId": formId,'environmentWebAPI': this.environmentWebAPI};
    this.createModal(SwDynamicFormLinkFormComponent,param,this.formLinkData.bind(this))
  }

  //获取关联表单选中的数据
  formLinkData(outDatas) {
    //表格选中的一行值
    let selectData = outDatas[0]
    //选中的表格对应的tableId
    let tableid = outDatas[1]
    this.elements.forEach(value=>{
      //当副数据表的tabeId相等时 
      if(value.tableId == tableid.tableId) {
        this.formValue[value.paramCode] = selectData[value.paramCode]
        if (value.requestUrl) {
          //决定数据来源
          let param1 = value.requestUrl.split("/")[1];
          //决定那条数据
          let param2 = value.requestUrl.split("/")[2];
          let requestData = value.requestData
          let type =value['controlType']; // 当前元素类型
          //为绑定的formId类型
          if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')) {
            let checkedDataValue = this.formValue[value.paramCode]+'';//设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
            if(checkedDataValue){
              this.information[value.paramCode] = [];
                let arr11 = checkedDataValue.split(','); //将保存的id（其id为单选或多选时 选中的id）字符串转为数组
                arr11.forEach(ele => {
                  //判断是否为is_xx true 或者false
                  if (ele == 'true') {
                    ele = '1'
                  } else if (ele == 'false') {
                    ele = '0'
                  }
                  requestData.forEach(val => {
                    if (ele == val.id) {
                      val.status = true;
                    }
                  })
                });
                //修改时  对存储信息变量 information 赋值 
                requestData.forEach(val => {
                  if (val.status) {
                    this.information[value.paramCode].push(val.id)
                  }
    
                })
              }
               //确定需要的数据
             value.requestData = requestData;
          }
        }
       
      }
    })
  }

 /**
   * 创建弹出框组件服务 
   * @param component  组件的对象
   * @param param  传递的参数
   * @param fun  回调喊出
   */
  createModal(component: any, param?: any, fun?: any) {
    //创建dom节点
    const com = document.createElement(component.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    const swPhotoAlbumComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(swPhotoAlbumComponentRef.hostView);
   
    //组件的关闭事件getFormLink
    swPhotoAlbumComponentRef.instance["callback"].subscribe(data => {
      if (data.code)
        if (fun)
          fun(data.data);
      document.body.removeChild(com);
      this.applicationRef.detachView(swPhotoAlbumComponentRef.hostView);
      swPhotoAlbumComponentRef.destroy()

    });

    //传递参数
    if(param)
        swPhotoAlbumComponentRef.instance["param"] = param;

    document.body.appendChild(com);
  }
  //以上为关联表单代码

  protected configCkeditor: any = {
    serverUrl: environment.fileWebAPI + "ueditor/ueditorCtrl?systemId=" + this.systemId.getSystemId() + "&flagDirectory=" + this.ueFlag,
    initialFrameHeight: 320,  //初始化编辑器高度,默认320
    autoFloatEnabled:false,
    initialFrameWidth: "100%"
  };
    //设置富文本编辑 只读和 取消只读操作
    setConfigCkeditor(val) {
      let config = this.configCkeditor
      config.readonly = val
      return config
    }

}

//接口
export interface FormInformtion {
  formName: string,
  formCode: string,
  areas: Array<any>,
  description: string,
  status: number,
  params: Array<any>
}
export interface ElementInformtion {
  id: number,
  tableId: string,
  columnId: string,
  controlType: string,
  type: string;
  paramName: string,
  paramCode: string,
  formula: string,
  validatePrompt: string,
  timeFormat: string,
  pictureFormat: string,
  fileFormat: string,
  defaultValue: string,
  isHidden: string,
  isNotNull: string,
  isQueryParam: string,
  isListParam: string,
  isFormParam: string,
  groupName: string,
  description: string,
  isDataRequest: number,
  className: string,
  requestUrl: string,
  rows: number,
  height: number,
  seq: number,
  length: number,
  minLength: number,
  listWidth: number
}
